/**
 * Detection de la connexion par le battement de coeur (plan, sections 1.1 et 1.4).
 *
 * navigator.onLine = false suffit a dire « hors ligne » ; navigator.onLine =
 * true ne prouve rien (un reseau local sans Internet, un portail captif, une
 * API en panne). Le poste n'est « en ligne » que si l'ERP a repondu au
 * battement de coeur.
 */

export const CONNECTION = Object.freeze({
    CHECKING: 'checking',
    ONLINE: 'online',
    OFFLINE: 'offline',
});

/**
 * Un battement de coeur, et ce qu'il dit de la connexion et du poste.
 *
 * @returns {Promise<{
 *   connection: 'online'|'offline',
 *   terminalStatus: 'ACTIVE'|'DISABLED'|'REVOKED'|'UNKNOWN'|null,
 *   serverTime: string|null,
 *   catalogStale: boolean,
 * }>}
 *   terminalStatus null : rien appris (hors ligne, ou serveur sature).
 *   UNKNOWN : l'ERP ne reconnait plus ce jeton.
 */
export async function checkConnection({ api, token, appVersion, catalogSnapshotId = null, nav = globalThis.navigator }) {
    const offline = { connection: CONNECTION.OFFLINE, terminalStatus: null, serverTime: null, catalogStale: false };
    if (nav && nav.onLine === false) return offline;
    try {
        // Instantane du catalogue en place (PR 1.4) : le serveur repond
        // catalog_stale si le sien est different.
        const beat = await api.heartbeat(token, catalogSnapshotId ? { appVersion, catalogSnapshotId } : { appVersion });
        let terminalStatus = 'ACTIVE';
        if (beat.revoked) terminalStatus = 'REVOKED';
        else if (beat.disabled) terminalStatus = 'DISABLED';
        return {
            connection: CONNECTION.ONLINE,
            terminalStatus,
            serverTime: beat.server_time || null,
            catalogStale: beat.catalog_stale,
        };
    } catch (error) {
        if (error && error.kind === 'http') {
            // 5xx : l'ERP ne peut rien recevoir, pour la caisse c'est hors ligne.
            if (error.status >= 500) return offline;
            if (error.status === 401) {
                return { connection: CONNECTION.ONLINE, terminalStatus: 'UNKNOWN', serverTime: null, catalogStale: false };
            }
            // 429 et autres 4xx : l'ERP repond, mais ce battement n'apprend rien.
            return { connection: CONNECTION.ONLINE, terminalStatus: null, serverTime: null, catalogStale: false };
        }
        // Reseau coupe, delai depasse, reponse illisible.
        return offline;
    }
}
